<template>
    <view-reservoir
        :get-reservoir-infos="$options.getReservoirInfos"
        include-water-gates
    />
</template>

<script>
import ViewReservoir from "@/modules/common/views/ViewReservoir";
import api from "../api";

export default {
    name: "Reservoir",
    components: {
        ViewReservoir
    },
    getReservoirInfos: api.reservoir.getReservoirInfos
};
</script>
